import type { FieldNote } from './store';

export type FieldNoteFeatureProperties = {
  type: FieldNote['type'];
  strokeWidth: number;
  isHovered: boolean;
  item: string;
  i?: number;
  compassHeading?: number;
};

/** Pure builder for the source's per-feature `properties` shape. Exported so it
 * can be unit-tested without mounting `react-map-gl` Source/Layer in JSDOM. */
export function buildFieldNoteFeatures(
  fieldNotes: readonly FieldNote[],
  hoveredId: string | undefined,
): Array<{ type: 'Feature'; geometry: GeoJSON.Point; properties: FieldNoteFeatureProperties }> {
  return fieldNotes.map((f) => {
    const compassHeading = f.type === 'image' ? (f.files?.[0]?.compassHeading ?? undefined) : undefined;
    return {
      type: 'Feature' as const,
      geometry: f.geometry,
      properties: {
        type: f.type,
        strokeWidth: f.id === hoveredId ? 5 : 2,
        isHovered: f.id === hoveredId,
        item: JSON.stringify(f),
        ...(f.i != null ? { i: f.i } : {}),
        ...(compassHeading != null ? { compassHeading } : {}),
      },
    };
  });
}
